import React from "react";
import { Box, Typography } from "@mui/material";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";
import DebouncedInput from "../../../../common/components/DebouncedTextfield";

const SecondStep = ({
  agent,
  openNav,
  closeNav,
  openBigTextArea,
  setAgent,
}) => {
  return (
    <>
      {openBigTextArea(() => closeNav(1), "context", agent?.context, 1)}
      <Box>
        <Typography className="font-14-grey" gutterBottom>
          Call Context
        </Typography>

        <DebouncedInput
          initialValue={agent?.context}
          onDebouncedUpdate={(val) => {
            let replacedString = val
              .replace(/\{\{OrganizationName\}\}/g, agent.organisationName)
              .replace(/\{\{AgentName\}\}/g, agent.agentName);

            setAgent((prev) => ({ ...prev, context: replacedString }));
          }}
          sx={commonStyles.inputField}
        />

        <span className="icon1" onClick={() => openNav(1)}>
          <span className="fas fa-expand"></span>
        </span>
      </Box>
    </>
  );
};

export default SecondStep;
